import { ErrorMessageContents } from '../../../helpers/hub'
import { QueueStats } from './types'

export const queueStatsFetch = () => ({ type: 'queueStats.fetch' } as const)
type QueueStatsFetchAction = ReturnType<typeof queueStatsFetch>

export const queueStatsAddQueueStats = (queueStats: QueueStats[]) =>
  ({ type: 'queueStats.addQueueStats', payload: queueStats } as const)
export type QueueStatsAddQueueStatsAction = ReturnType<
  typeof queueStatsAddQueueStats
>

export const queueStatsFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'queueStats.fetchFail', payload: error, error: true } as const)
export type QueueStatsFetchFailAction = ReturnType<typeof queueStatsFetchFail>

export type QueueStatsAction =
  | QueueStatsFetchAction
  | QueueStatsAddQueueStatsAction
  | QueueStatsFetchFailAction
